import './base.scss';

export default class Base {
  protected debug: boolean;

  constructor(debug: boolean = false) {
    this.debug = debug;
  }

  log(...args: any[]): void {
    if (this.debug) {
      console.log(`DEBUG [${this.constructor.name}]:`, ...args);
    }
  }

  logObject(...args: any[]): void {
    if (this.debug) {
      console.log(`DEBUG OBJECT [${this.constructor.name}]:`);
      console.dir(...args);
    }
  }
}